
import React, {useState ,useEffect} from 'react';
import {Link} from "react-router-dom";
import {_printNumber} from '../../helpers/helpers.js'

import {ASNsPageResult, BiggestASN} from '../../../../server/routes/asn.js'

interface ASNListProps {
	title: string;
	list: BiggestASN[];
}

interface ASNRowProps {
	asn: BiggestASN;
	requireAuthentication?: boolean;
}

export default function ASN({server, pageData}: {server: string, pageData: unknown}) {

    const typedPageData = pageData as ASNsPageResult;
	let [data, setData] = useState(typedPageData);

	return (
        <>
            <ASNHeader props={data}/>
            <ASNBody props={data}/>
        </>
	)
}


function ASNHeader({props}: {props: ASNsPageResult}) {
    function handleSubmit(event: React.FormEvent): void {
        event.preventDefault()
        var q = document.getElementById('q') as HTMLInputElement;
        let t=String(q.value).trim();       
        document.location = '/asn/'+t;
      } 

    return (
        <section className="section section-sm text-center">
            <div className="container">
                <div className="text-center">
                    <h2>ASN Lookup</h2>
                    <p>
                        <span style={{maxWidth: '690px'}}>
                            Search Autonomous System Number (ASN) by name or number.
                        </span>
                    </p>
                </div>

                <div>			
                    <form className="rd-form rd-search form-inline" action="search" method="GET"  onSubmit={handleSubmit}>
                        <div className="form-wrap">
                            <input required type="number" className="form-input" title="Lookup Autonomous System Number (ASN) by number" placeholder="Lookup Autonomous System Number (for example 13335)" name="q" id="q"/>
                        </div>
                        <div className="form-wrap form-button">
                            <button className="button button-secondary button-shadow" type="submit" >Search</button>
                        </div>
                    </form>
                </div>            
            </div>
        </section>
    )
}


function ASNBody({props}: {props: ASNsPageResult}) {
    if (!props.BiggestASN) return (<></>);
	return (
        <>
            <section className="section section-sm">
                <div className="container">
                    <div className="row row-50">
                        <div className="col-md-12 col-lg-12 col-xl-12">
                            <ASNList title='Largest ASNs ranked by number of hosted domains' list={props.BiggestASN}/>
                        </div>
                    </div>
                </div>
            </section>
        </>
	)
};


function ASNList({title, list}: ASNListProps) {
return (
<>
        <h4>{title}</h4>    
        <br/>    
        <div className="table-outer table-rounded table-responsive-lg">
        <table className="table-custom table-custom-striped table-custom-primary  ">
                <thead>
                <tr>
                        <th style={{width: '10%'}}>ASN</th>
                        <th style={{width: '30%'}}>ASN Name</th> 
                        <th style={{width: '30%'}}>Top ranking Domain</th>
                 {/**      <th style={{width: '15%'}}>Top IP</th> */}
                        <th style={{width: '20%'}}>Domain Count</th>                
                </tr>
                </thead>
                        <tbody>
                        {
                                list.map((asn, indexKey) => {
                                        return (
                                                <ASNRow asn={asn} key={indexKey}/>
                                        )
                                })
                        }	
                </tbody>
        </table>
        </div>
        
</>
)
}

function ASNRow({asn, requireAuthentication}: ASNRowProps) {
    if (!asn) return (<></>);

return (
        <>
        <tr>         
            <td>                
                <Link 
                    to={`/asn/${asn.ASNId}`} 
                    className="link-hover" 
                >
                    <b>{asn.ASNId} </b>
                </Link> 	
            </td>       
            <td>	                     
                {asn.ASNName}							
            </td>
            <td>                
                <Link 
                    to={`/website/${asn.HighestRankDomain}`} 
                    className="link-hover" 
                >
                    <b>{asn.HighestRankDomain}</b>
                </Link> 
            </td>
            {/** 
            <td>                
                <Link 
                    to={`/ip/${asn.HighestRankIp}`} 
                    className="link-hover" 
                >
                <b>{asn.HighestRankIp}</b>
                </Link> 
            </td>*/}
            <td>               
                <Link 
                    to={`/asn/${asn.ASNId}/websites`} 
                    className="link-hover" 
                >
                    <b>{_printNumber(asn.DomainCount)}</b>
                </Link> 
            </td>            
        </tr>		
        </>
)
}
